import React from 'react';
import { Heading } from 'rebass';
import { pipe, find, pathOr, propEq, propOr } from 'ramda';
import { getElementId, useWebformElement } from '../utils';

export const WebformMarkup = ({ element, error }) => {
	const id = getElementId(element.name);
	// eslint-disable-next-line
	const [inputProps, settings] = useWebformElement(element, {
		className: 'form-control',
		name: element.name,
		type: element.type,
		id
	});

	const markup = pipe(pathOr([], ['attributes']), find(propEq('name', '#markup')), propOr(null, 'value'))(element);

	return (
        <Heading sx={{ flexBasis: '100%', textAlign: 'center', fontSize: 6 }} px={2} mb={4} dangerouslySetInnerHTML={{ __html: markup }} />
	)
};

export default WebformMarkup;
